module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "dialog-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "ts-dialog--wrapper",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.handleWrapperClick($event)
      }
    }
  }, [_c('div', {
    ref: "dialog",
    staticClass: "ts-dialog",
    style: ({
      width: _vm.boxWidth
    })
  }, [_c('div', {
    class: ['ts-dialog--header', 'onepx-b', {
      'center': !_vm.$slots.title
    }]
  }, [_c('span', {
    staticClass: "ts-dialog--title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("title"), _vm._v(" "), (_vm.showClose) ? _c('i', {
    staticClass: "ts-dialog--close",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("×")]) : _vm._e()], 2), _vm._v(" "), (_vm.rendered) ? _c('div', {
    staticClass: "ts-dialog--body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ts-dialog--footer onepx-t"
  }, [(!_vm.$slots.footer) ? [(_vm.type === 'confirm') ? _c('button', {
    staticClass: "ts-dialog--button is-cancel",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]) : _vm._e(), _vm._v(" "), (_vm.type === 'confirm') ? _c('button', {
    staticClass: "ts-dialog--button is-confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.alertText))]) : _vm._e(), _vm._v(" "), (_vm.type === 'alert') ? _c('button', {
    staticClass: "ts-dialog--button is-confirm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.alertText))]) : _vm._e()] : _vm._e(), _vm._v(" "), _vm._t("footer")], 2)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-25d5f1d8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Components/common/tsDialog.vue
// module id = 806
// module chunks = 39